import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured')({
  loader: async ({ context }) => {
    await context.getInstance('i18n', '@myn/mui');
    await context.getInstance('i18n', '@mint-lib/tw-components');
    await context.getInstance('i18n', '@mint-lib/ai-chat');
    await context.getInstance('flagsmith', '@mint/arm');
  },
  async beforeLoad({ context, location }) {
    if (!(await context.isAuthenticated())) {
      console.log('redirecting to login from secured route');
      throw redirect({
        to: '/login',
        search: {
          next: location.href,
        },
      });
    }

    return context;
  },
});
